import { useEffect } from "react";
import { useQuery, useSubscription, useMutation } from "@apollo/client";
import { useDispatch } from "react-redux";
import {
  QUERY_FP_ANALYSIS_DATA,
  SUBSCRIBE_FP_ANALYSIS_DATA,
  MUTATE_SET_FULL_WET_SESSION,
  MUTATE_SET_WET_PERIOD,
} from "../queries/fpAnalysisQueries";
import { setFPAnalysisData } from "../../../state/fpAnalysisReducer";

export function QueryFPAnalysisData() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_FP_ANALYSIS_DATA);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setFPAnalysisData(data.getFPAnalysisData));
    }
  }, [dispatch, data, loading, error]);
}

export function SubscribeFPAnalysisData() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_FP_ANALYSIS_DATA, {
    onData: (x) => {
      const fpAnalysisUpdate = x.data.data.newFPAnalysisUpdate;
      dispatch(setFPAnalysisData(fpAnalysisUpdate));
    },
  });
  if (error) {
    console.log(error);
  }
}

export function MutateSetFullWetSession() {
  const [setFullWetSession] = useMutation(MUTATE_SET_FULL_WET_SESSION);
  return setFullWetSession;
}

export function MutateSetWetPeriod() {
  const [setWetPeriod] = useMutation(MUTATE_SET_WET_PERIOD);
  return setWetPeriod;
}
